import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Input,
  Form,
  Space,
  Button,
  Drawer,
  Select
} from '@lockerpm/design';

import {
} from '@ant-design/icons';

import itemsComponents from '../../../../components/items';
import commonComponents from '../../../../components/common';

import projectServices from '../../../../services/project';
import resourceServices from '../../../../services/resource';
import environmentServices from '../../../../services/environment';

import global from '../../../../config/global';
import storeActions from '../../../../store/actions';

function FormData(props) {
  const { ProgrammingLanguage } = itemsComponents;
  const { OnboardingTooltip } = commonComponents;
  const { t } = useTranslation();
  const {
    visible = false,
    item = null,
    onClose = () => { },
    onReload = () => { }
  } = props
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace);
  const projects = useSelector((state) => state.project.projects);

  const [form] = Form.useForm()
  const [callingAPI, setCallingAPI] = useState(false);
  const [newProjectId, setNewProjectId] = useState(null);
  const [programmingLanguages, setProgrammingLanguages] = useState([]);

  const projectName = Form.useWatch('name', form);

  useEffect(() => {
    fetchProgrammingLanguages();
  }, [])

  useEffect(() => {
    if (newProjectId && !!projects.find((p) => p.id === newProjectId)) {
      createDefaultEnvs(newProjectId);
    }
  }, [newProjectId, projects])

  useEffect(() => {
    if (visible) {
      setNewProjectId(null)
      if (item) {
        form.setFieldsValue({
          name: item.name,
          description: item.description,
          programming_language: item.programming_language || "",
        })
      } else {
        form.setFieldsValue({
          name: '',
          description: '',
          programming_language: ""
        })
      }
    } else {
      form.resetFields();
    }
  }, [item, visible])

  const fetchProgrammingLanguages = () => {
    resourceServices.list_programming_languages().then((response) => {
      setProgrammingLanguages(response?.filter((k) => k !== 'go'));
    }).catch(() => {
      setProgrammingLanguages([])
    })
  }

  const handleSave = async () => {
    form.validateFields().then(async (values) => {
      const project = await projectServices.get_payload(values, selectedWorkspace.id)
      let request = null
      setCallingAPI(true);
      if (item) {
        request = projectServices.update(item.id, values)
      } else {
        request = projectServices.create(project)
      }
      await request?.then(async (response) => {
        if (!item) {
          setNewProjectId(response.id);
          // update onboarding process
          global.store.dispatch(storeActions.updateChangeProcessKey('step_1'));
        }
        onReload(values);
        setTimeout(async () => {
          handleClose();
        }, 1000);
      }).catch((error) => {
        global.pushError(error)
      })
      setCallingAPI(false);
    })
  }

  const createDefaultEnvs = async (projectId) => {
    const defaultEnvs = [
      {
        name: 'Production',
        externalUrl: '',
        description: '',
      },
      {
        name: 'Staging',
        externalUrl: '',
        description: '',
      },
      {
        name: 'Development',
        externalUrl: '',
        description: '',
      }
    ]
    const requests = defaultEnvs.map(async (value) => {
      const environment = await environmentServices.get_payload(value, projectId);
      return environmentServices.create(projectId, environment)
    })
    await Promise.all(requests)
    setNewProjectId(null)
  }


  const handleClose = () => {
    form.resetFields();
    onClose()
  }

  return (
    <div className={props.className}>
      <Drawer
        title={item ? t('projects.edit') : t('projects.new')}
        placement="right"
        onClose={handleClose}
        open={visible}
        footer={
          <Space className='flex items-center justify-end'>
            <Button
              disabled={callingAPI}
              onClick={handleClose}
            >
              {t('button.cancel')}
            </Button>
            <Button
              type="primary"
              disabled={!projectName || !projectName.trim()}
              loading={callingAPI}
              onClick={handleSave}
            >
              {item ? t('button.save') : t('button.create')}
            </Button>
          </Space>
        }
      >
        <Form
          form={form}
          layout="vertical"
          labelAlign={'left'}
        >
          <Form.Item
            name={'name'}
            label={<div>
              <p className='font-bold'>{t('project.name')}</p>
              <span>{t('project.name_desc')}</span>
            </div>}
            rules={[
              global.rules.REQUIRED(t("project.name")),
            ]}
          >
            <Input
              size="medium"
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
          <Form.Item
            name={'description'}
            label={<div className='flex flex-col gap-1'>
              <p className='font-bold'>{t('common.description')}</p>
            </div>}
            rules={[]}
          >
            <Input.TextArea
              disabled={callingAPI}
              className='w-full'
              placeholder={t('placeholder.enter')}
            />
          </Form.Item>
          <Form.Item
            name={'programming_language'}
            label={<div className='flex items-center'>
              <p className='font-bold mr-2'>{t('project.programming_language')}</p>
              <OnboardingTooltip
                title={t('onboarding.programming_language')}
                placement="top"
              />
            </div>}
          >
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              disabled={callingAPI}
            >
              {programmingLanguages.map((language) => (
                <Select.Option
                  value={language}
                  key={language}
                >
                  <ProgrammingLanguage
                    name={language}
                  />
                </Select.Option>
              ))}
              <Select.Option
                value={""}
                key={"other"}
              >
                <ProgrammingLanguage
                  name={""}
                  label={"Other"}
                />
              </Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default FormData;
